module.exports = function (app) {
    app.service("paState", ["$state", "$q", "$cookies", "brand", "brandConfig", "services", function ($state, $q, $cookies, brand, brandConfig, services) {

        //this.curPlanAdmin = {
        //    dataDifferentiator : "",
        //    loginId : "",
        //    firstName : "",
        //    lastName : "",
        //    company : "",
        //    email : "",
        //    telephone : "",
        //    fax : "",
        //    address : "",
        //    city : "",
        //    state : "",
        //    zipCode : "",
        //    clientId : 321988,
        //    userId : 0,
        //    clientNumber : "",
        //    passwordTempFlag : false,
        //    "loggedIn" : true,
        //    displayLoginId : "",
        //    emailAvailable : false
        //}
        //
        //this.curEmp =  {
        //    dataDifferentiator : "",
        //    clientId : "",
        //    clientName : "",
        //    effectiveFromDate : "",
        //    clientType : "",
        //    clientStatus : "",
        //    partnerId : "",
        //    partnerCode : "",
        //    clientNumber : ""
        //}
        //this.config = {
        //    isAnEdit: false
        //}
        //this.currentValues = {
        //    clientName: '',
        //    clientNumber: '',
        //    clientId: '',
        //    loginId: '',
        //    config: {
        //        isAnEdit: false
        //    }
        //}
        // Cache for saving multiple employees in case you want to allow leaving the page and coming back without destroying data.

    }]);
}